import { useEffect, useState } from "react";

import type { ChallengeState } from "~/modules/cap/server-cap";
import capSolver from "~/modules/cap/solver";
import { spawnDetached } from "~/utils/async";

export type CapProps = {
	/** @default false */
	enabled?: boolean;

	hiddenTokenInputName?: string;

	onTokenChange?(token: string): void;
};

export default function Cap({
	enabled = false,
	hiddenTokenInputName,
	onTokenChange,
}: CapProps) {
	const [challenge, setChallenge] = useState<null | ChallengeState>(null);
	const [token, setToken] = useState<null | string>(null);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		return spawnDetached(async (signal) => {
			const res = await fetch("/api/cap/challenge", {
				headers: {
					Accept: "application/json",
				},
				signal,
			});
			const resData = (await res.json()) as ChallengeState;
			setChallenge(resData);
		});
	}, [enabled]);

	useEffect(() => {
		if (!challenge) {
			return;
		}
		const data = challenge;

		return spawnDetached(async (signal) => {
			const solutions = await capSolver(data.challenge);
			const res = await fetch("/api/cap/redeem", {
				body: JSON.stringify({
					token: data.token,
					solutions,
				}),
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				signal,
			});
			const resData = await res.json();
			setToken(resData.token);
		});
	}, [challenge]);

	useEffect(() => {
		if (onTokenChange && token) {
			onTokenChange(token);
		}
	}, [token, onTokenChange]);

	if (token && hiddenTokenInputName) {
		return (
			<input type="hidden" name={hiddenTokenInputName} value={token} />
		);
	} else {
		return null;
	}
}
